<template>

  <span></span>

</template>


<script type="text/babel">

  import Typed from 'typed.js';

  export default {

    data() {
      return {
        instance: null
      }
    },

    props: {
      to: { type: String, default: '' },
      from: { type: String, default: '' },
      duration: { type: Number, default: 0 }
    },

    computed: {
      strings: function(){
        let to = this.to.split(); let from = this.from.split();
        return from.concat(to);
      }
    },

    methods: {
      init() {
        const vm = this;
        if (!vm.instance) {
          let options = {
            strings: vm.strings,
            typeSpeed: vm.duration,
            backSpeed: vm.duration,
            showCursor: false
          };
          vm.instance = new Typed( vm.$el, options)
        }
      }
    },

    mounted() {
      this.init();
    },
  }

</script>